export type ActivityRetentionYears = 1 | 2 | 3 | 5 | 7 | 10 | null

export const activityRetentionOptions = [
  { value: 'all', years: null, label: 'Keep everything' },
  { value: '1', years: 1, label: '1 year' },
  { value: '2', years: 2, label: '2 years' },
  { value: '3', years: 3, label: '3 years' },
  { value: '5', years: 5, label: '5 years' },
  { value: '7', years: 7, label: '7 years' },
  { value: '10', years: 10, label: '10 years' },
] as const

export const activityRetentionCaption =
  'Removes registrations, enrolments, email sends and clicks older than this. Money and memberships stay.'

export function activityRetentionLabel(years: number | null | undefined) {
  if (years === undefined) return 'Not available'
  return activityRetentionOptions.find((option) => option.years === years)?.label ?? 'Not available'
}

export function shorterRetention(next: ActivityRetentionYears, current: ActivityRetentionYears) {
  if (next === null) return false
  return current === null || next < current
}

export const activityRetentionLinks: Record<string, { text: string; href: string }> = {
  GB: {
    text: 'ICO guidance',
    href: 'https://ico.org.uk/for-organisations/uk-gdpr-guidance-and-resources/data-protection-principles/a-guide-to-the-data-protection-principles/the-principles/storage-limitation/',
  },
  US: {
    text: 'IRS guidance',
    href: 'https://www.irs.gov/businesses/small-businesses-self-employed/how-long-should-i-keep-records',
  },
}
